// @ts-nocheck -- legacy receiving contracts are migrated incrementally below.
import { useState } from "react";

import { makePostApiCall } from "../../../shared/makeApiCall";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";
import {
  cleanFiltersForRequest,
  createDefaultOperationalDateRange,
} from "../../../shared/filterUtils";
import { SnackbarData, SnackbarType } from "../../../components/Snackbar";
import { generateUniqueNumber } from "../../../shared/utility";

export function AllReceivingInvoicesViewModel(logout, addSnackbar) {
  const defaultFilters = createDefaultOperationalDateRange();
  const [filters, setFilters] = useState(defaultFilters);
  const [showDates, setShowDates] = useState(false);
  const [search, setSearch] = useState("");

  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [receivingInvoices, setReceivingInvoices] = useState({
    data: [],
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });

  const getReceivingInvoices = async function (searchValue, page, dateFilters) {
    const resolvedSearch =
      searchValue !== undefined && searchValue !== null ? searchValue : search;
    const resolvedDates = dateFilters ?? filters;
    setLoading(true);
    const payload = {
      page: page,
      search: resolvedSearch,
      filters: cleanFiltersForRequest(resolvedDates),
    };
    let callResult = await makePostApiCall(`receivingInvoices`, payload);
    setLoading(false);
    if (callResult.success) {
      setReceivingInvoices(callResult.data);
      if (searchValue !== undefined && searchValue !== null) {
        setSearch(searchValue);
      }
      if (dateFilters !== undefined) {
        setFilters(dateFilters);
      }
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const resetFilters = async function () {
    const restoredDates = createDefaultOperationalDateRange();
    setFilters(restoredDates);
    setSearch("");
    await getReceivingInvoices("", 1, restoredDates);
  };

  const deleteReceivingInvoice = async function (invoiceId, index) {
    let callResult = await makePostApiCall(
      `deleteReceivingInvoice/${invoiceId}`,
      {},
    );
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });
      getReceivingInvoices(search, 1);

      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success,
        ),
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeleteReceivingInvoice = function (invoice, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteReceivingInvoice(invoice.id, index)}
          message={`Are you sure you want to delete invoice ${invoice.invoice_number} from ${invoice.supplier_name}?`}
          setOpen={setEmptyModelOpen}
        />
      ),
      open: true,
    });
  };

  return {
    askDeleteReceivingInvoice,
    emptyModal,
    getReceivingInvoices,
    resetFilters,
    loading,
    receivingInvoices,
    setSlideOver,
    slideOver,
    setEmptyModelOpen,
    setFilters,
    showDates,
    setShowDates,
    filters,
    search,
  };
}
